import { render, staticRenderFns } from "./FeedbacksExercice.vue?vue&type=template&id=2571d751&scoped=true&"
import script from "./FeedbacksExercice.vue?vue&type=script&lang=js&"
export * from "./FeedbacksExercice.vue?vue&type=script&lang=js&"
import style0 from "./FeedbacksExercice.vue?vue&type=style&index=0&id=2571d751&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2571d751",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAlert,VBtn,VContainer,VForm,VTextarea})
